import {
  HeartPulse, Wheat, GraduationCap, SunMedium, HandHeart, Stethoscope, Syringe, Pill, Bandage, Megaphone,
  Ambulance, Scale, Shield, Feather, Users, Gift, Ban, Crown, Sprout, Fish, TreePine, Warehouse, Cpu, Zap,
  Car, ChefHat, Flame, Sofa, Scissors, Sparkles, Leaf, Recycle, BookOpen, Brain, Music, Droplets, Accessibility,
  Handshake, Globe2, Building2, Truck, UserPlus, Baby, Home,
} from "lucide-react";

export const IMG = {
  maleba: "/assets/ma-leba.webp",
  logoOng: "/assets/logo-ong.webp",
  logoAsso: "/assets/logo-association.webp",
  health: "https://images.unsplash.com/photo-1666887360361-d4e8487f0026?crop=entropy&cs=srgb&fm=webp&q=70&w=1400",
  health2: "https://images.unsplash.com/photo-1536064479547-7ee40b74b807?crop=entropy&cs=srgb&fm=webp&q=70&w=1400",
  agri: "https://images.unsplash.com/photo-1509099381441-ea3c0cf98b94?crop=entropy&cs=srgb&fm=webp&q=70&w=1400",
  agri2: "https://images.unsplash.com/photo-1607240204413-e51a4afa6f12?crop=entropy&cs=srgb&fm=webp&q=70&w=1400",
  training: "https://images.unsplash.com/photo-1709207515848-37e74d455909?crop=entropy&cs=srgb&fm=webp&q=70&w=1400",
};

export const RECEPISSES = {
  ong: "Récépissé n° 013/025/MID/DGAT/DLPC/SAP — Siège : Makana 2, République du Congo",
  association: "Récépissé n° 328/23/MIDDL/DBZV/SG/DDAT/SR du 18 août 2023 — Préfecture du département de Brazzaville",
};

export const MISSIONS = [
  { icon: HeartPulse, title: "Santé", text: "Premiers soins médicaux d'urgence et accès aux soins gratuits." },
  { icon: Wheat, title: "Sécurité alimentaire", text: "Agriculture, élevage, pisciculture et maraîchage." },
  { icon: GraduationCap, title: "Formation", text: "Formation professionnelle et apprentissage aux métiers." },
  { icon: SunMedium, title: "Énergie solaire & eau potable", text: "Accès à l'énergie solaire et à l'eau potable." },
  { icon: HandHeart, title: "Personnes vulnérables", text: "Soutien aux personnes vulnérables, handicapées et âgées." },
];

export const PAGES = {
  "ong-presentation": {
    universe: "ong", eyebrow: "ONG MA LEBA", title: "Présentation",
    intro: "Organisation Non Gouvernementale Humanitaire et Développement, l'ONG MA LEBA est dédiée à l'aide aux premiers soins médicaux d'urgence, sur les sites de Makana 1 et Makana 2.",
    image: IMG.health, seo: "Présentation de l'ONG MA LEBA : objet et missions selon les statuts.",
    sections: [{ title: "Notre objet et nos missions", items: [
      { icon: Ambulance, title: "Premiers soins d'urgence", text: "Aide aux premiers soins médicaux d'urgence et accès aux soins gratuits." },
      { icon: GraduationCap, title: "Formation & insertion", text: "Formation et insertion des jeunes et des personnels de santé." },
      { icon: Sprout, title: "Développement agricole", text: "Développement agricole et sécurité alimentaire." },
      { icon: SunMedium, title: "Énergie & eau", text: "Accès à l'énergie solaire et à l'eau potable." },
      { icon: HandHeart, title: "Populations vulnérables", text: "Appui aux populations vulnérables." },
    ] }],
  },
  "ong-health": {
    universe: "ong", eyebrow: "ONG MA LEBA", title: "Nos activités de santé",
    intro: "Des soins de proximité, gratuits en situation d'urgence, pour les communautés de Makana et des zones périphériques.",
    image: IMG.health2, seo: "Activités de santé de l'ONG MA LEBA : premiers soins, consultations, vaccination, sensibilisation.",
    sections: [{ title: "Ce que nous faisons", items: [
      { icon: Ambulance, title: "Premiers soins d'urgence", text: "Prise en charge immédiate des blessés et des malades." },
      { icon: Stethoscope, title: "Consultations de base", text: "Consultations médicales de premier niveau." },
      { icon: Bandage, title: "Soins infirmiers & pansements", text: "Soins infirmiers courants et pansements." },
      { icon: Pill, title: "Médicaments essentiels", text: "Mise à disposition de médicaments essentiels." },
      { icon: Syringe, title: "Vaccination & dépistage", text: "Campagnes de vaccination et de dépistage." },
      { icon: Megaphone, title: "Sensibilisation", text: "Hygiène, nutrition, santé maternelle et infantile." },
      { icon: Truck, title: "Orientation & évacuation", text: "Orientation et évacuation des cas graves." },
    ] }],
  },
  "ong-principles": {
    universe: "ong", eyebrow: "ONG MA LEBA", title: "Nos principes",
    intro: "Les valeurs qui guident chacune de nos interventions.",
    image: IMG.health, seo: "Principes de l'ONG MA LEBA : humanité, impartialité, neutralité, indépendance.",
    sections: [{ title: "Sept principes fondamentaux", items: [
      { icon: HeartPulse, title: "Humanité" },
      { icon: Scale, title: "Impartialité" },
      { icon: Shield, title: "Neutralité" },
      { icon: Feather, title: "Indépendance" },
      { icon: Gift, title: "Gratuité des soins d'urgence" },
      { icon: Ban, title: "Non-discrimination" },
      { icon: Crown, title: "Dignité" },
    ] }],
  },
  "asso-presentation": {
    universe: "association", eyebrow: "ASSOCIATION MA LEBA (A.M.L)", title: "Présentation",
    intro: "Association à caractère social, Groupement Agricole et Centre de Formation Professionnelle et d'Apprentissage aux Métiers, active sur Makana 1 et Makana 2.",
    image: IMG.agri, seo: "Présentation de l'ASSOCIATION MA LEBA : objectifs selon les statuts.",
    sections: [{ title: "Nos objectifs", items: [
      { icon: HandHeart, title: "Aider les personnes en difficulté" },
      { icon: UserPlus, title: "Insertion socio-professionnelle" },
      { icon: Ambulance, title: "Prise en charge médicale d'urgence gratuite", text: "Pour les personnes démunies." },
      { icon: Sprout, title: "Agriculture & élevage", text: "Agriculture, élevage, pisciculture, arboriculture, horticulture, maraîchage." },
      { icon: GraduationCap, title: "Formation aux métiers" },
      { icon: SunMedium, title: "Énergie solaire & eau potable" },
      { icon: Accessibility, title: "Accompagnement", text: "Personnes vulnérables, en situation de handicap et personnes âgées abandonnées." },
    ] }],
  },
  "asso-agri": {
    universe: "association", eyebrow: "Groupement Agricole", title: "Pôle agricole",
    intro: "Le Groupement Agricole de Makana 1 et 2 développe une agriculture de proximité au service de la sécurité alimentaire.",
    image: IMG.agri2, seo: "Pôle agricole de l'ASSOCIATION MA LEBA : maraîchage, élevage, pisciculture, transformation.",
    sections: [{ title: "Nos filières agricoles", items: [
      { icon: Wheat, title: "Agriculture vivrière & maraîchage" },
      { icon: Fish, title: "Élevage & pisciculture" },
      { icon: TreePine, title: "Arboriculture & horticulture" },
      { icon: Warehouse, title: "Transformation & conservation", text: "Transformation et conservation des produits agricoles." },
    ] }],
  },
};

export const FILIERES = [
  { icon: Cpu, title: "Informatique et intelligence artificielle" },
  { icon: Zap, title: "Électricité et installation de panneaux solaires" },
  { icon: Car, title: "Mécanique automobile" },
  { icon: ChefHat, title: "Restauration, boulangerie et pâtisserie" },
  { icon: Flame, title: "Soudure et métallerie" },
  { icon: Sofa, title: "Décoration d'intérieur" },
  { icon: Scissors, title: "Couture et stylisme (Espace Couture)" },
  { icon: Sparkles, title: "Coiffure et esthétique" },
  { icon: Leaf, title: "Fabrication du manioc" },
  { icon: Recycle, title: "Entretien de l'environnement" },
  { icon: BookOpen, title: "Apprentissage de la lecture et de l'outil informatique" },
  { icon: Ambulance, title: "Gestion des soins d'urgence (GSU)" },
  { icon: Brain, title: "Santé mentale" },
  { icon: Music, title: "Formation par la musique" },
];

export const PRIORITY = ["Jeunes sans moyens", "Personnes en situation de handicap", "Personnes vulnérables", "Personnes âgées abandonnées"];

export const PARTNER = {
  who: ["ONG", "Associations", "Fondations", "Entreprises", "Institutions", "Bailleurs", "Donateurs"],
  why: [
    { icon: HeartPulse, title: "Impact direct", text: "Vos contributions atteignent directement les communautés." },
    { icon: Handshake, title: "Collaboration durable", text: "Un partenariat construit sur le long terme." },
    { icon: Globe2, title: "Visibilité internationale", text: "Associez votre nom à une action humanitaire concrète." },
    { icon: Users, title: "Responsabilité sociale", text: "Donnez du sens à votre engagement." },
  ],
  domains: [
    "Appui médical et logistique", "Formation du personnel de santé", "Soutien financier et matériel",
    "Échanges d'expertise", "Missions humanitaires", "Construction et équipement de centres",
    "Soutien aux femmes et aux enfants", "Développement communautaire", "Volontariat",
  ],
  domainIcons: [Stethoscope, GraduationCap, Gift, Brain, Globe2, Building2, Baby, Home, Droplets],
};

export const COUNTRIES = [
  ["Congo (Brazzaville)", "+242"], ["RD Congo", "+243"], ["France", "+33"], ["Belgique", "+32"], ["Suisse", "+41"],
  ["Canada", "+1"], ["États-Unis", "+1"], ["Royaume-Uni", "+44"], ["Allemagne", "+49"], ["Italie", "+39"],
  ["Espagne", "+34"], ["Gabon", "+241"], ["Cameroun", "+237"], ["Angola", "+244"], ["Côte d'Ivoire", "+225"],
  ["Sénégal", "+221"], ["Maroc", "+212"], ["Autre", "+"],
];

export const STRUCTURE_OPTIONS = [["ong", "ONG MA LEBA"], ["association", "ASSOCIATION MA LEBA"], ["les_deux", "Les deux"]];
export const STRUCTURE_LABEL = { ong: "ONG", association: "Association", commun: "Commun", les_deux: "Les deux" };
export const SUBJECT_OPTIONS = [
  ["information", "Information"], ["partenariat", "Partenariat"], ["benevolat", "Bénévolat"], ["formation", "Formation"],
  ["don", "Don"], ["presse", "Presse"], ["autre", "Autre"],
];
export const STATUS_LABEL = { nouveau: "Nouveau", en_cours: "En cours", traite: "Traité" };
export const EXPECTED_DOCS = {
  ong: ["Statuts de l'ONG MA LEBA", "Règlement intérieur (santé)", "Bureau exécutif"],
  association: ["Statuts de l'ASSOCIATION MA LEBA", "Règlement intérieur (Groupement Agricole et Centre de Formation)", "Bureau exécutif"],
};
